import React from 'react';

const OrderContext = React.createContext({});
const OrderProvider = OrderContext.Provider;

export { OrderContext, OrderProvider };
